var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "operator-wrapper" },
    [
      _c("sec-title", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.noData,
            expression: "!noData"
          }
        ],
        attrs: { isShowHelp: false }
      }),
      _vm._v(" "),
      _c("income", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.noData,
            expression: "!noData"
          }
        ],
        model: {
          value: _vm.isIncome,
          callback: function($$v) {
            _vm.isIncome = $$v
          },
          expression: "isIncome"
        }
      }),
      _vm._v(" "),
      _c("token-list", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.noData,
            expression: "!noData"
          }
        ],
        model: {
          value: _vm.isTokenList,
          callback: function($$v) {
            _vm.isTokenList = $$v
          },
          expression: "isTokenList"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.noData,
              expression: "noData"
            }
          ],
          staticClass: "become-operator"
        },
        [
          _c("span", { staticClass: "no-operator" }),
          _vm._v(" "),
          _c("div", { staticClass: "text" }, [
            _vm._v(_vm._s(_vm.$t("tradeOperator.noOperator")))
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "btn __pointer",
              on: { click: _vm.goOperatorTutorial }
            },
            [_vm._v(_vm._s(_vm.$t("tradeOperator.learnMore")))]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }